import React from 'react';
import styles from './styles.scss';
import {translate} from "react-i18next";


export const AgreementUI = (props) => (
    <div className={styles.agreement}>
        {props.t("buttons.agreement")}
        <a href={"/file.pdf"} className={styles.agreementButton} download={"Пользовательское соглашение Boosters.pro.pdf"}>
            PDF, 1.2 МБ
        </a>
    </div>
);


export const Agreement =  translate((props) => props.namespaces)(AgreementUI);


// WEBPACK FOOTER //
// src/components/utils/agreement/index.jsx